export const isSameValue = <T, K>(valueA: T, valueB: K) => Object.is(valueA, valueB);
